// extracted by mini-css-extract-plugin
module.exports = {"circle":"Circle-circle-b387","image":"Circle-image-b387"};